import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ConstantsService } from '../../../services/constants/constants.service';
import { InsightsService } from 'src/app/services/insights/insights.service';
import moment from 'moment';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-insights-v2',
  templateUrl: './insights-v2.component.pug',
  styleUrls: ['./insights-v2.component.scss'],
  standalone: false
})
export class InsightsV2Component implements OnInit, AfterViewInit, OnChanges {
  @Input() start!: any;
  @Input() end!: any;
  @Input() request!: any;
  @Input() survey!: any;
  @Input() pulseDepartments!: any;
  @Input() department: any;
  @Input() filterBy!: any;
  metric: any = [];

  expanded = false;
  mainText = $localize`Organisational performance metrics scores`;
  positiveScores: any = [];
  negativeScores: any = [];
  expansionText: any = $localize`Show more`;
  initialized = false;

  constructor(
    private insightsService: InsightsService,
    private permissions: PermissionsService
  ) {}

  ngAfterViewInit(): void {}

  ngOnInit(): void {
    this.initialized = true;
    if (this.initialized) {
      this.positiveScores = [];
      this.negativeScores = [];
      this.assignMetrics(
        this.start,
        this.end,
        this.request,
        this.pulseDepartments,
        this.survey
      );
    }
  }
  sortMetrics(array){
    return array.sort(
      (a, b) => b['value'] - a['value']
    );
  }
  assignMetrics(start, end, request, department, survey) {
    let departmentToSend = '';
    if (!start) {
      start = moment('1970-01-01T00:00:00.000');
    }
    if (!end) {
      end = moment(new Date());
    }
    if (department.length < 1) {
      department = '';
    }
    else {
      department.forEach((element) => {
        departmentToSend += element.id + ',';
      });
      departmentToSend = departmentToSend.substring(
          0,
          departmentToSend.length - 1
        );
      }
    this.insightsService
        .getPulseInsightsMetrics(start, end, request, departmentToSend, survey)
        .subscribe((res) => {
          for (var i = 0; i < res.pulse_metrics.length; i++) {
            let icon_map =
              ConstantsService.METRICS_ICON_MAP[res.pulse_metrics[i].metric];
            if (icon_map != undefined)
              res.pulse_metrics[i].metric = icon_map['label'];
            let value = res.pulse_metrics[i].value;
            res.pulse_metrics[i].value = (
              Math.round(((9 * (value - 1)) / 4 + 1) * 10) / 10
            ).toFixed(1);
            if (res.pulse_metrics[i].metric == 'Other') {
              continue;
            }
            res.pulse_metrics[i].icon = icon_map['metric_without_background_amber_icon'];
            if (res.pulse_metrics[i].value > 6) {
              this.positiveScores.push(res.pulse_metrics[i]);
            } else {
              this.negativeScores.push(res.pulse_metrics[i]);
            }
          }
          this.negativeScores.sort((a, b) => (a.value < b.value ? 1 : -1));
          this.metric = this.sortMetrics([...this.positiveScores, ...this.negativeScores])
          this.positiveScores.sort((a, b) => (a.value < b.value ? 1 : -1));
        });
  }

  ngOnChanges(): void {
    if (this.initialized) {
      this.positiveScores = [];
      this.negativeScores = [];
      this.assignMetrics(
          this.start,
          this.end,
          this.request,
          this.pulseDepartments,
          this.survey
        );
      }

    if (this.pulseDepartments.length === 1) {
      this.mainText = $localize`Department performance metrics scores: ${this.pulseDepartments[0]['department']} `;
    } else {
      this.mainText = $localize`Organisational performance metrics scores`;
    }
  }

  assignMetricImage(metric) {
    return ConstantsService.METRICS_ICON_MAP[metric.metric][
      'metric_without_background_amber_icon'
    ];
  }

  showMore() {
    let transiionBlock =  "pf-blocks-single-block"
    let collapsedBlock = "performance-single-blocks-collapsed"
    let expandedBlock = "performance-single-blocks-expanded"
    let doc = document.getElementById(transiionBlock);
    this.expanded = !this.expanded;
    if (this.expanded && doc) {
      this.expansionText = $localize`Show less`;
      doc.classList.add(expandedBlock);
      doc.classList.remove(collapsedBlock);
    } else {
      this.expansionText = $localize`Show more`;
      doc?.classList.remove(expandedBlock);
      doc?.classList.add(collapsedBlock);
    }
  }
}
